export const drawerTabs: string[] = [
  "Location Information",
  "Description",
  "Mission Statement",
  "Code of Conduct",
  "Privacy Statement",
  "Staff Description",
  "Misc Information",
  "Social Media Platforms",
  "Events",
  "User Roles",
  "Communications",
  "Partners"
];
